import {defineMessages} from 'react-intl';

export default defineMessages({
    title: {
        id: 'app.signup.invalidToken.title',
        defaultMessage: 'Invalid link'
    },
    description: {
        id: 'app.signup.invalidToken.description',
        defaultMessage: 'This link is not valid'
    }
});
